import { $http, buildHeaders } from "./index";

//获取验证码
export const captcha = () => {
  return $http.get("/approve/Login/captcha", {
    headers: {
      unAuth: true,
    },
  });
};

//登录验证
export const judgeLogin = (data) => {
  return $http.post("/approve/Login/doLogin", data, {
    headers: {
      ...buildHeaders(3, "正在验证登录信息，请稍后……"),
      unAuth: true,
    },
  });
};

//获取登录用户信息
export const get_loginuser = () => {
  return $http.get("/approve/Admin/info");
};

//获取未审批的发薪申请单
export const check_list = (params) => {
  return $http.get("/approve/SalaryApply/checkList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取已审批的发薪申请单
export const checked_list = (params) => {
  return $http.get("/approve/SalaryApply/checkedList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取发薪申请单详情
export const detail = (id) => {
  return $http.get("/approve/SalaryApply/checkInfo?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//提交审批
export const check = (data) => {
  return $http.post("/approve/SalaryApply/check", data, {
    headers: buildHeaders(3),
  });
};

//登出
export const loginout = (params) => {
  return $http.get("/approve/Login/logout", {
    params,
    headers: buildHeaders(3, "登出中，请稍后……"),
  });
};
